export default "__VITE_PUBLIC_ASSET__dcac279f__"